import { Controller } from '@hotwired/stimulus';
import Pagy from '../pagy.mjs';

export default class PagyInitializerController extends Controller {
  connect() {
    Pagy.init(this.element);
  }

  disconnect() {
    this.element.innerHTML = '';
  }
}
